import React, { useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import GoogleLogin from "react-google-login";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import fssLogo from "../../assets/images/FSS Logo.png";
import { Breakpoint } from "../../utils/theme";

const LoginForm = ({ state, handleChange, handleSubmit, responseGoogle }) => {
  const [showPassword, setShowPassword] = useState(false);
  const isMob = Breakpoint();

  return (
    <Box display="grid">
      <img
        src={fssLogo}
        style={{
          height: "55px",
          ...(isMob
            ? {
                marginBottom: "10px",
              }
            : {
                marginLeft: "auto",
              }),
        }}
      />
      <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
        Welcome!
      </Typography>

      <Typography variant="subtitle2" gutterBottom>
        Enter your credentials to access your account.
      </Typography>
      <form className="login-form">
        <FormControl margin="normal" fullWidth size="small">
          <InputLabel>Username</InputLabel>
          <OutlinedInput
            label="Username"
            name="userName"
            value={state.userName}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl margin="normal" fullWidth size="small">
          <InputLabel>Password</InputLabel>
          <OutlinedInput
            label="Password"
            name="password"
            value={state.password}
            onChange={handleChange}
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

        <Button
          type="submit"
          onClick={handleSubmit}
          variant="contained"
          fullWidth
          sx={{ my: 2 }}
          // disabled={state.userName == "" || state.password == ""}
        >
          Login
        </Button>
      </form>

      <Typography className="or-text">- OR -</Typography>
      <GoogleLogin
        className="google-btn"
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        theme="dark"
        onSuccess={responseGoogle}
        onFailure={responseGoogle}
      />
    </Box>
  );
};

export default LoginForm;
